import { useEffect } from 'react';
import PageHeader from '../../components/PageHeader';
import {
    RESEARCH_AREAS,
    AREA_TAGS,
    AREA_TAG_COLOR,
    AREA_KPI,
    RESEARCH_ROUTE_MAP,
} from '../../config/data';
import { usePage, PAGES } from '../../context/PageContext';
import { t } from '../../utils/i18n';
import './index.css';

export default function ResearchOverviewPage() {
    const { navigate } = usePage();
    useEffect(() => {
        document.title = t('研究方向 · 至知创新研究院', 'Research · IQuest Research');
    }, []);
    return (
        <div className="page-shell">
            <PageHeader
                eyebrow="Research"
                title={t('研究方向', 'Science')}
                subtitle={t(
                    '围绕大模型、医疗智能、生命科学、数学智能、数智电力五大研究方向，深耕基础算法与高复杂度场景的落地能力。',
                    'Centered on Large Models, Medical AI, Life Sciences, Mathematics, and Electric Power Intelligence, we go deep in foundational algorithm development and high‑complexity application deployment.'
                )}
            />
            <section className="section research-overview-section">
                <div className="container">
                    <div className="research-overview-grid">
                        {RESEARCH_AREAS.map((area) => {
                            const to = RESEARCH_ROUTE_MAP[area.id] || PAGES.HOME;
                            const tags = AREA_TAGS[area.id] || [];
                            const colorClass = AREA_TAG_COLOR[area.id] || '';
                            const kpi = AREA_KPI[area.id];
                            return (
                                <button
                                    type="button"
                                    key={area.id}
                                    className="research-overview-card"
                                    onClick={() => navigate(to)}
                                >
                                    <div className="research-overview-img">
                                        <img src={area.img} alt={area.title} loading="lazy" decoding="async" />
                                    </div>
                                    <div className="research-overview-body">
                                        <div className="research-overview-title">{area.title}</div>
                                        <p className="research-overview-desc">{area.desc}</p>
                                        {kpi && <div className="research-overview-kpi">{kpi}</div>}
                                        {tags.length > 0 && (
                                            <div className="research-overview-tags">
                                                {tags.map((tag) => (
                                                    <span className={`home-research-tag ${colorClass}`} key={tag}>{tag}</span>
                                                ))}
                                            </div>
                                        )}
                                        <div className="research-overview-more">
                                            {t('进入研究方向', 'Learn More')}
                                            <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                                                <path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
}
